export default __webpack_public_path__ + "static/media/marketing.a6a7687a.svg";